module.exports = {
  IS_LOGGED_IN_ERROR: 100
};




// WEBPACK FOOTER //
// ./src/helpers/errorCodes.js